import { createSlice } from "@reduxjs/toolkit";
export const Common = createSlice({
  name: "Common",
  initialState: {
    vmBranches: []
  },
  reducers: {
    setVMBranches: (state, action) => {
      state.vmBranches = action.payload;
    }
  },
});

export const {setVMBranches} = Common.actions;
export default Common.reducer;
